import { RefObject } from "react";

import { AppModalWithGuards, AppModalWithGuardsProps } from "../../Modals/AppModalWithGuards";
import { FormWrapperHandle } from "./BaseEntityCreateUpdate";

export interface BaseEntityCreateUpdateModalProps extends Omit<AppModalWithGuardsProps, "guards"> {
  formWrapperRef: RefObject<FormWrapperHandle | null>;
}

export interface BaseEntityCreateUpdateModalInheritableProps extends Omit<
  BaseEntityCreateUpdateModalProps,
  "children" | "formWrapperRef"
> {}

export function BaseEntityCreateUpdateModal({
  formWrapperRef,
  children,
  ...otherProps
}: BaseEntityCreateUpdateModalProps) {
  return (
    <AppModalWithGuards
      {...otherProps}
      guards={{
        formDirty: {
          formWrapperRef: formWrapperRef,
        },
      }}
    >
      {(params) => children(params)}
    </AppModalWithGuards>
  );
}
